import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./Navbar.module.scss";
// Common components
import Button from "../../common/others/Button";
// Sub components
import Menu from "./sub-components/Menu";
import AuthSection from "./sub-components/AuthSection";
import UserSection from "./sub-components/UserSection";
// Redux actions
import { open } from "../../../redux/reducers/sidebar";
// Utils
import icons from "../../../utils/icons";

const Navbar = () => {
  // Hooks
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  // Redux and states
  const isLoggedIn = useSelector((state) => state.userData.isLoggedIn);
  const [showSlideMenu, setShowSlideMenu] = useState(false);
  // Conditions and variables
  const renderMenu = !pathname.startsWith("/panel");
  const isForPanel = pathname.startsWith("/panel");
  const containerClassName = `${styles.navbar} ${
    isForPanel ? styles["for-panel"] : ""
  }`;
  // Functions
  function handleSlideButton() {
    !isForPanel ? setShowSlideMenu(true) : dispatch(open());
  }
  useEffect(() => {
    setShowSlideMenu(false);
  }, [pathname]);

  return (
    <nav className={containerClassName}>
      <Button onClick={handleSlideButton}>{icons.slideMenu}</Button>

      {renderMenu && (
        <Menu
          slideMenuDisplayStatue={showSlideMenu}
          toggle={setShowSlideMenu}
        />
      )}

      {isLoggedIn ? <UserSection /> : <AuthSection />}
    </nav>
  );
};

export default Navbar;
